const cardData = [
  {
    "id": 1,
    "title": "KEY POINT",
    "subtitle": "secureFileSharing",
    "titleClass": "text-gray-900",
    "textWidthClass": "md:w-3/5",
    "isLeft": false,
    "textPosition": "justify-center",
    "descriptionPosition": "text-left",
    "imgClass": "w-[50%] mx-auto",
    "descriptionList": [
      "shareYourFiles"
    ],
    "icon": true,
    "image": "products/pages/file-cloud/3.png"
  },
  {
    "id": 2,
    "subtitle": "ntfs_ad",
    "titleClass": "text-gray-900",
    "textWidthClass": "",
    "isLeft": true,
    "textPosition": "justify-center",
    "descriptionPosition": "text-left",
    "imgClass": "w-[50%] mx-auto",
    "descriptionList": [
      "ntfs_ad_desc",
    ],
    "icon": true,
    "image": "products/pages/file-cloud/4.png"
  },
  {
    "id": 3,
    "subtitle": "office_outlook",
    "titleClass": "text-left text-gray-900",
    "textWidthClass": "md:w-3/5",
    "isLeft": false,
    "textPosition": "justify-center",
    "descriptionPosition": "text-left",
    "imgClass": "w-[50%] mx-auto",
    "descriptionList": [
      "office_outlook_desc"
    ],
    "icon": true,
    "image": "products/pages/file-cloud/5.png"
  },
  {
    "id": 4,
    "subtitle": "admin_tools_1",
    "titleClass": "text-left text-gray-900",
    "textWidthClass": "",
    "isLeft": true,
    "textPosition": "justify-center",
    "descriptionPosition": "text-left",
    "imgClass": "w-[80%] mx-auto",
    "descriptionList": [
      'admin_tools_1_desc'
    ],
    "icon": true,
    "image": "products/pages/file-cloud/6.png"
  },
  {
    "id": 5,
    "subtitle": "free_clients",
    "titleClass": "text-left text-gray-900",
    "textWidthClass": "",
    "isLeft": false,
    "textPosition": "justify-center",
    "descriptionPosition": "text-left",
    "imgClass": "w-[50%] mx-auto",
    "descriptionList": [
      "free_clients_desc"
    ],
    "icon": true,
    "image": "products/pages/file-cloud/7.png"
  },
  {
    "id": 6,
    "subtitle": "admin_tools_2",
    "titleClass": "text-left text-gray-900",
    "textWidthClass": "",
    "isLeft": true,
    "textPosition": "justify-center",
    "descriptionPosition": "text-left",
    "imgClass": "w-[40%] mx-auto",
    "descriptionList": [
      "admin_tools_2_desc"
    ],
    "icon": true,
    "image": "products/pages/file-cloud/8.png"
  },
  {
    "id": 7,
    "subtitle": "branding",
    "titleClass": "text-left text-gray-900",
    "textWidthClass": "",
    "isLeft": false,
    "textPosition": "justify-center",
    "descriptionPosition": "text-left",
    "imgClass": "w-[60%] mx-auto",
    "descriptionList": [
      "branding_desc"
    ],
    "icon": true,
    "image": "products/pages/file-cloud/9.png"
  },
  {
    "id": 8,
    "subtitle": "advanced",
    "titleClass": "text-left text-gray-900",
    "textWidthClass": "",
    "isLeft": true,
    "textPosition": "justify-center",
    "descriptionPosition": "text-left",
    "imgClass": "w-[60%] mx-auto",
    "descriptionList": [
      'advanced_desc'
    ],
    "icon": true,
    "image": "products/pages/file-cloud/10.png"
  },
  {
    "id": 9,
    "subtitle": "gdpr",
    "titleClass": "text-left text-gray-900",
    "textWidthClass": "",
    "isLeft": false,
    "textPosition": "justify-center",
    "descriptionPosition": "text-left",
    "imgClass": "w-[60%] mx-auto",
    "descriptionList": [
      "gdpr_desc"
    ],
    "icon": true,
    "image": "products/pages/file-cloud/11.png"
  },
]

export {
  cardData
};
